module.exports = __webpack_public_path__ + "static/media/boy_and_dog.9b7bad20.svg";